import { connect } from "react-redux";

import { RootState } from "@app/store/rootReducer";

import EditFilesPanel from "../../components/EditFilesPanel";
import {
  bulkUpdateFiles,
  clearAllUploadedDealFiles,
  deleteDealFile,
  downloadDealFile,
  fetchThumbnail,
  uploadDealFiles,
} from "../store/actions";
import { areFilesUploading } from "../store/selectors";

const mapStateToProps = (state: RootState) => ({
  fileUploading: areFilesUploading(state),
});

const mapDispatchToProps = {
  clearAllUploadedFiles: clearAllUploadedDealFiles,
  onDelete: deleteDealFile.request,
  onDownload: downloadDealFile,
  onFetchThumbnail: fetchThumbnail,
  onUpdateFiles: bulkUpdateFiles.request,
  onUpload: uploadDealFiles.request,
};

const Files = connect(mapStateToProps, mapDispatchToProps)(EditFilesPanel);
export default Files;
